import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { State } from './types'
import createSagaMiddleware from 'redux-saga'
import AppSaga from '../sagas'
import { createBrowserHistory } from 'history'
import createRootReducer from './reducers'

export const history = createBrowserHistory()

export default function configureStore(preloadedState?: State) {
  const sagaMiddleware = createSagaMiddleware()

  const middlewares = [sagaMiddleware]

  const middlewareEnhancer = applyMiddleware(...middlewares)

  const enhancers = [middlewareEnhancer]
  const composedEnhancers = composeWithDevTools(...enhancers)

  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composedEnhancers,
  )
  sagaMiddleware.run(AppSaga)

  return store
}
